module.exports = __webpack_public_path__ + "static/media/pourya.d389b03f.png";